import { RootContext } from "./chunk-CFH6T5NP.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/base/Root/Root.tsx
import { forwardRef, useMemo, useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CLASSNAME_MAP = {
  brand: {
    printdeal: "pd:root--printdeal",
    impressto: "pd:root--impressto"
  }
};
var DEFAULT_COMPONENT = "div";
var Root = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      brand,
      className,
      iconSpritePath,
      brandSpritePath,
      brandSectionBgWhitePath,
      brandSectionBgPrimaryPath
    } = _b,
    rest = __objRest(_b, ["as", "children", "brand", "className", "iconSpritePath", "brandSpritePath", "brandSectionBgWhitePath", "brandSectionBgPrimaryPath"]);
  const Component = as || DEFAULT_COMPONENT;
  const parentContext = useContext(RootContext);
  const context = useMemo(() => ({
    iconSpritePath: parentContext.iconSpritePath || iconSpritePath,
    brandSpritePath: parentContext.brandSpritePath || brandSpritePath,
    brand: parentContext.brand || brand,
    brandSectionBgWhitePath: parentContext.brandSectionBgWhitePath || brandSectionBgWhitePath,
    brandSectionBgPrimaryPath: parentContext.brandSectionBgPrimaryPath || brandSectionBgPrimaryPath
  }), [iconSpritePath, brandSpritePath, brand, brandSectionBgWhitePath, brandSectionBgPrimaryPath, parentContext]);
  return /* @__PURE__ */jsx(RootContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
      ref,
      className: clsx("pd:root", brand && CLASSNAME_MAP.brand[brand], className)
    }, rest), {
      style: {
        ["--pd-branded-section-bg-white"]: "url(".concat(context.brandSectionBgWhitePath, ")"),
        ["--pd-branded-section-bg-primary"]: "url(".concat(context.brandSectionBgPrimaryPath, ")")
      },
      children
    }))
  });
});
var Root_default = Root;
export { Root_default };